import React from "react";
import "./styles/vision.css";
const Vision = () => {
  const content = [
    {
      number: "20+",
      name: "Publisher",
    },
    {
      number: "20+",
      name: "Reseachers",
    },
    {
      number: "200+",
      name: "Live Surveys",
    },
  ];
  return (
    <>
      <section className="vision-section">
        <div className="container vision-container">
          <h1>Shaping the Future of App Monetization</h1>
          <div className="vision-content">
            <div className="vision">
              <p className="vision-title">
                Vision{" "}
                <span>
                  <img src="/images/vi.svg" alt="" />
                </span>
              </p>
              <p
                style={{
                  lineHeight: "160%",
                }}
              >
                To revolutionize app monetization by delivering a seamless,
                rewarding survey experience that benefits both publishers and
                users. We aim to empower apps of all sizes to unlock new revenue
                streams through high-quality, targeted engagement.
              </p>
            </div>
            <div className="mission-div">
              <p className="vision-title">Mission 
              <span>
                  <img src="/images/vi.svg" alt="" />
                </span>
              </p>
              <p
                style={{
                  lineHeight: "160%",
                }}
              >
                To become the most trusted and innovative survey monetization
                platform globally — enabling millions of users to earn
                meaningfully while helping publishers grow faster, smarter, and
                more sustainably.
              </p>
            </div>
          </div>
          {/* box */}
          <div className="box-container">
            {content.map((val, i) => (
              <Box name={val.name} number={val.number}></Box>
            ))}
          </div>
        </div>
        <div className="box-white">
          <div className="white-box-abl"></div>
        </div>
      </section>

      <section className="white-brands">
        <div className="container white-brand-container">
          <h1>Brands Growing With Us </h1>
          <p>
            At Real Opinion, we don’t just offer a monetization tool — we build
            lasting partnerships. Our platform is trusted by a growing network
            of innovative apps, publishers, and digital brands who are focused
            on scaling revenue through smarter engagement.
          </p>
        </div>
      </section>
    </>
  );
};

export default Vision;

const Box = ({ number, name }) => (
  <div className="box">
    <h1>{number}</h1>
    <p>{name}</p>
  </div>
);
